<header class="topbar">
  <div class="topbar-in">
    <a class="brand" [attr.aria-label]="'topbar.home' | translate" routerLink="/">
      <!-- Le logo porte déjà le nom : le titre textuel ferait doublon -->
      <img class="brand-logo" src="assets/images/logo_login_no_bg.png" alt="Keep Control" />
    </a>

    <span class="spacer"></span>

    <button
      class="langbtn"
      [attr.aria-label]="'topbar.changeLanguage' | translate"
      (click)="openLangSheet()"
      type="button"
    >
      <kc-icon [iconParams]="languageIcon" [size]="1.1" aria-hidden="true" />
      <span>{{ currentLang().toUpperCase() }}</span>
    </button>

    <button class="session" (click)="goToAccount()" type="button">
      <span class="ini">
        @if (auth.initials(); as initials) {
          {{ initials }}
        } @else {
          <kc-icon [iconParams]="userIcon" [size]="1.1" aria-hidden="true" />
        }
      </span>
      <!-- Le nom du visiteur ne traverse PAS le pipe de traduction : c'est une donnée, pas une clé.
           Et c'est la présence d'une session, jamais le nom, qui décide du libellé — le nom vient
           d'un appel qui peut échouer. -->
      <span class="who">
        @if (auth.isLoggedIn()) {
          {{ auth.displayName() ?? ('topbar.myAccount' | translate) }}
        } @else {
          {{ 'topbar.signIn' | translate }}
        }
      </span>
    </button>
  </div>
</header>

@if (isLangSheetOpen()) {
  <app-sheet-shell [ariaLabel]="'topbar.language' | translate" (close)="closeLangSheet()">
    <h3>{{ 'topbar.language' | translate }}</h3>
    <p>{{ 'topbar.languageHint' | translate }}</p>
    <div class="rows">
      @for (lang of langs; track lang.code) {
        <button class="row" (click)="selectLang(lang)" type="button">
          <span class="row-thumb" aria-hidden="true">
            <kc-icon [iconParams]="languageIcon" [size]="1.3" />
          </span>
          <span class="row-main">
            <!-- Endonyme : « Deutsch » se cherche tel quel, dans n'importe quelle langue -->
            <span class="row-title">{{ lang.name }}</span>
            <span class="row-sub">{{ lang.code.toUpperCase() }}</span>
          </span>
          <span class="row-aside">
            @if (currentLang() === lang.code) {
              <span class="pill conforme">
                <i class="dot"></i>
                {{ 'topbar.languageActive' | translate }}
              </span>
            }
          </span>
        </button>
      }
    </div>
  </app-sheet-shell>
}
